<template>
    <v-dialog persistent v-model="courseAttendanceDialog.dialog" class="aaop">
        <v-card class="attendance-box blue-title">
            <v-card-title class="text-xs-center font-weight-bold pb-0">
                <v-spacer></v-spacer>
                    <span class="font-16">Confirmation of Course attendance</span>
                <v-spacer></v-spacer>
                <div class="header-close font-weight-regular">1 / {{courseAttendanceDialog.count}}</div>
            </v-card-title>
            <v-card-text>
                Dear Teacher :<br>
                <!-- &#8195;&#8195;Please confirm whether you can attend the class on <span class="font-weight-bold">{{absentMsg.classTime | formatDate}}</span> as normal.<br>
                If you cannot attend the class, we will <span class="font-weight-bold pink-text">cancel</span> the class for you automatically. -->
                &#8195;&#8195;Please confirm if you can attend the class on <span class="font-weight-bold">{{courseAttendanceDialog.classTime }}</span><br>
                If there is no choice from you before 30 min of the class or you choose "No", the class will be cancelled automatically and you will get the penalty according to the rule.<br>
                &#8195;&#8195;Please note that there will be 3 times penalty for each class if you do not click it before 30 minutes.The deduction rule in details is below:<br>
              <!-- :loading="loading" -->
                <v-data-table
          :headers="referrals.headers"
          :items="referrals.desserts"
          hide-actions
         
          no-data-text="No Data!"
          class="common-table"
          style="margin-top:30px"
        >
          <template slot="items" slot-scope="props">
            <td>{{ props.item.one }}</td>
            <td>{{ props.item.two }}</td>
            <td>{{ props.item.three}}</td>
          </template>
        </v-data-table>
            </v-card-text>
            <v-card-actions class="pb-3">
                <v-layout justify-center>
                    <v-btn class="text-none blue-button dialog-submit mr-4"
                        @click="isCanAttendance(true)">Yes, I can</v-btn>
                    <v-btn class="text-none red-button dialog-submit"
                        @click="isCanAttendance(false)">No, I can't</v-btn>
                </v-layout>
            </v-card-actions>
        </v-card>
        <v-dialog
            v-model="dialog"
            :max-width="options.width"
            v-bind:style="{ zIndex: options.zIndex }"
            >
            <v-form ref="form">
                <v-container fluid>
                    <v-layout>
                    <v-flex xs12 md12>
                        <v-card flat>
                            <v-card-text class="pb-0">
                                <v-layout row>
                                <v-flex xs4 pr-4>
                                    <v-subheader>Class Time:<span class="require-sign">*</span></v-subheader>
                                </v-flex>
                                <v-flex xs7>
                                    <v-text-field
                                        single-line
                                        outline
                                        box
                                        class="body-2"
                                        disabled
                                        :value="courseAttendanceDialog.classTime | formatDate"
                                        ></v-text-field>
                                </v-flex>
                            </v-layout>
                            <v-layout row>
                                <v-flex xs4 pr-4>
                                    <v-subheader>Cancel the reason:<span class="require-sign">*</span></v-subheader>
                                </v-flex>
                                <v-flex xs7>
                                    <v-autocomplete :items="reasons"
                                        single-line
                                        outline
                                        box
                                        v-model="reasonValue"
                                        class="body-2"
                                        :rules="[rules.required]"
                                        ></v-autocomplete>
                                </v-flex>
                            </v-layout>

                            <v-layout row>
                                <v-flex xs4 pr-4>
                                    <v-subheader>Note:<span class="require-sign">*</span></v-subheader>
                                </v-flex>
                                <v-flex xs7>
                                        <v-textarea v-model="cancleRemark"
                                            single-line
                                            outline
                                            no-resize
                                            rows="3"
                                            class="body-2"
                                            :rules="[rules.required]"
                                            ></v-textarea>
                                </v-flex>
                            </v-layout>

                            <v-layout row>
                                <v-flex xs4 pr-4>
                                    <v-subheader> The attachment upload:<span class="require-sign">*</span></v-subheader>
                                </v-flex>
                                <v-flex xs4>
                                    <input v-show="0"
                                        type="file"
                                        class="upload"
                                        ref="inputer"
                                        multiple
                                        @change="uploadAttachmentFile"
                                        id="attachmentFile"
                                        accept=".jpg,.png" />
                                    <v-text-field
                                        single-line
                                        outline
                                        box
                                        class="body-2"
                                        disabled
                                        v-model="fileName"
                                        :rules="[rules.required]"
                                        ></v-text-field>
                                </v-flex>
                                <v-flex xs3 pl-1>
                                    <v-btn
                                        color="grey accent-4"
                                        class="text-none white--text mt-0"
                                        @click="openAttachmentFile">Select the file</v-btn>
                                </v-flex>
                            </v-layout>

                            <v-layout justify-center>
                                <v-btn class="text-none white--text pl-5 pr-5 ml-5 blue-button height28"
                                    @click="submit">Submit</v-btn>
                            </v-layout>
                            </v-card-text>
                        </v-card>
                    </v-flex>
                    </v-layout>
                </v-container>
            </v-form>
    </v-dialog>
    </v-dialog>
</template>
<script>
import { formatDate } from '@/utils/date.js'
import dateFileter from '@/filters/dateFilter'
import vmodel from "@/mixins/v-model";
import { validationMixin } from "vuelidate";
import {
    required,
    maxLength
} from "vuelidate/lib/validators";

import { uploader } from "@/utils/patchUpload.js";
import { _debounce } from "@/utils/tools.js";
import { absentNoticeOperate } from '@/api/layout'

export default {
  props: {
    courseAttendanceDialog: {
        dialog:false,
        classTime:"",
        id:"",
        count:0
    },
  },
    data:()=>({
        formLoading: false,
        valid: false,
        options:{
            width: 700,
            zIndex: 200
        },
        dialog: false,
        reasons: [
            { value: 1, text: 'LAG' },
            { value: 2, text: 'Internet Issue' },
            { value: 3, text: 'Brownout' },
            { value: 4, text: 'Family Reason' },
            { value: 5, text: 'Equipment Problem (computer,headset,etc...)' },
            { value: 6, text: 'Personal Reason' }
        ],
        IsICan:false,
        reasonValue: 0,
        cancleRemark: '',
        fileName: '',
        attachmentFile: null,
        rules: {
            required: v => !!v || 'Required.'
        },
        referrals: {
      isOpen: false,
      headers: [
        {
          text: "Cancellation time",
          sortable: false,
          value:"one",
        },
        {
          text: "Penalty for each class",
          sortable: false,
          value:"two",
        },
        {
          text: "Teaching point deduction",
          sortable: false,
          value:"three",
        },
      ],
      desserts: [
        {
          one: "CLASS TIME<3hrs",
          two: "3 times lesson fee",
          three: 2,
        },
        {
          one: "24hrs>CLASS TIME>3hrs",
          two: "100% lesson fee",
          three: 2,
        },
        {
          one: "48hrs>CLASS TIME>24hrs",
          two: "50% lesson fee",
          three: 2,
        },
        {
          one: "72hrs>CLASS TIME>48hrs",
          two: "25% lesson fee",
          three: 2,
        }
      ],
    },
    }),
    mounted(){
       
    },
    computed:{
        absentMsg:function () {
            return this.$store.state.message.absentMsg
        }
    },
    methods: {
        isCanAttendance(v){
            this.IsICan = v;
            if(v){
                this.submit()
            }else {
                this.dialog = true;
            }
        },
        openAttachmentFile () {
            document.getElementById('attachmentFile').click()
        },
        uploadAttachmentFile (event) {
            this.attachmentFile = event.target.files[0]
            this.fileName = this.attachmentFile.name
        },
        submit:_debounce(async function(){
            if(!this.IsICan){
                if (!this.$refs.form.validate()) {
                    console.log('form-error')
                    return
                }
                
                var _uploader=new uploader({
                    module:'Attachment',
                    progressbar: this.$root.$progressbar,
                    alert: this.$root.$alert
                })
                var uploadResult = await _uploader.upload(this.attachmentFile)
                if(uploadResult.ErrorCode!=0){
                    this.$root.$alert(uploadResult.Msg||'Upload fail.')
                    return
                }
            }
            
            var requestParam={
                Id:this.courseAttendanceDialog.id,
                IsICan:this.IsICan,
                Attachment:this.IsICan?'':uploadResult.Body,
                CancelReason:this.reasonValue,
                CancelRemark:this.cancleRemark
            }
            absentNoticeOperate(requestParam).then(res => {
                this.$store.dispatch('closeAbsentMsg')
                if (res.data.ErrorCode === 0 && res.data.Body===1) {
                    this.dialog = false
                } else {
                    this.$root.$alertTips(res.data.Msg, '',{ icon: { default:true } });
                }
            })
        })
    },
    filters:{
        formatDate(time) {
            return formatDate(time, "MM/dd/yyyy hh:mm");
        }
    },
    watch: {
        dialog: function(value){
            if (!value) {
                if (this.$refs['form'] !== undefined) {
                    this.$refs['form'].resetValidation()
                    this.reasonValue = 0;
                    this.cancleRemark = "";
                    this.attachmentFile = null;
                    this.fileName = "";
                }
            }
        }
    }
}
</script>
<style lang="scss" scoped>
.attendance-box{
    width: 875px;
    height:580px;
    position: fixed;
    left:50%;
    top: 50%;
    transform:translate(-50%,-50%);
    border-radius:5px;
    box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.34);
    z-index: 200;
    .font-16{
        font-size:16px;
    }
    .header-close{
        position: absolute;
        right: 6px;
        top: 3px;
    }
}

</style>
